import React, { memo, useState, useCallback, useEffect, useMemo } from 'react';
import { CnButton, CnDropdown, CnMenu, CnMenuItem } from '@sto/cn-ui';
import styles from './index.module.scss';
import { request } from "@/api/request";
import { useChatContext } from '@/store/chatContext';
// import mockData from './1.json';

export const zcRobots = [
  'J241104001', // 政策测试机器人
  'J241112001', // 政策预发机器人
  'J241112001', // 政策生产机器人
];

// eslint-disable-next-line react/prop-types
const FastQuestion = ({ onSubmit, robotCode, onClickFastQuestionTag, isShow }) => {
  const [list, setList] = useState([]);
  const { isDataAnalysisMode, toggleDataAnalysisMode } = useChatContext();
  const [show, setShow] = useState(true);

  useEffect(() => {
    setShow(isShow);
  }, [isShow]);

  const getValues = useCallback(() => {
    request({
      name: 'robotChat.getHotQuestion',
      data: { platform: 'WEB' }
    }).then(({ data }) => {
      setList(data || []);
      // setList(mockData || []);
    });
  }, []);

  const renderTags = useMemo(() => {
    if (!show) return null;
    return list?.map((item: any) => {
      const { content, taskType, questionList } = item;
      if (questionList?.length > 0) {
        const isFormTag = questionList[0].keyWordList; // 判断是否是表单类型
        if (isFormTag) {
          // 表单类型（快捷表单键入）
          return (
            <CnButton
              size="small"
              key={taskType || content}
              onClick={() => {
                onClickFastQuestionTag && onClickFastQuestionTag(item);
              }}
            >
              {content}
            </CnButton>
          );
        } else {
          // 菜单项类型（浮框展示，点击浮框项触发）
          const menu = (
            <div style={{ padding: '15px 0' }}>
              <CnMenu>
                {questionList.map(({ question }) => (
                  <CnMenuItem key={question} onClick={() => onSubmit({ content: question })}>
                    {question}
                  </CnMenuItem>
                ))}
              </CnMenu>
            </div>
          );
          return (
            <div key={taskType || content}>
              <CnDropdown
                triggerType="click"
                trigger={(
                  <CnButton style={{ marginRight: 8 }} size="small">
                    {content}
                  </CnButton>
                )}
              >
                {menu}
              </CnDropdown>
            </div>
          );
        }
      }
      // 普通类型（直接点击触发）
      return (
        <CnButton
          size="small"
          key={taskType || content}
          onClick={() => onSubmit({ content })}
        >
          {content}
        </CnButton>
      );
    });
  }, [list, onSubmit, onClickFastQuestionTag, show]);

  useEffect(() => {
    getValues();
  }, [getValues]);

  return (
    <div className={styles.fastQuestion}>
      {/* 数据分析按钮暂时隐藏 */}
      {/* {zcRobots.includes(robotCode) && (
        <CnButton
          key="data-analysis"
          className={`${styles.dataAnalysisButton} ${isDataAnalysisMode ? styles.active : ''}`}
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            toggleDataAnalysisMode();
          }}
        >
          数据分析
        </CnButton>
      )} */}
      
      {renderTags}
    </div>
  );
};

export default memo(FastQuestion);
